<style lang="scss">
  .how-to-page{
    .video-card{
      .card-title{
        color: #007BFF;
      }

      .video-player-box{
        max-height: 400px;
      }

      .vjs-big-play-button{
        top: 50% !important;
        left: 50% !important;
        transform: translate(-50%, -50%) !important;
      }
    }
  }
</style>
<template>
  <div class="theme-color-wrapper p-2 pt-0 how-to-page">
    <div class="row">
      <div class="col-12">
        <h2 cy="page-title" class="font-weight-bolder mb-1">How To</h2>
        <router-link :to="{ name: 'dashboard' }" class="body-text">
          &laquo; Back to dashboard
        </router-link>
      </div>
    </div>

    <div class="row my-3">
      <div class="col-12">
        <how-to-section title="Before a call" :videos="videosPrecall"></how-to-section>
        <how-to-section title="During a call" :videos="videosDuringCall"></how-to-section>
        <how-to-section title="After a call" :videos="videosAfterCall"></how-to-section>
      </div>
    </div>
  </div>
</template>

<script>
  import HowToSection from './HowToSection';
  export default {
    components: {
      HowToSection
    },
    data() {
      return {
        videosPrecall: [
          {
            title: 'Review a call request',
            description: 'This video will show you how to accept or reject a call request if your establishment allows the family members to book via the Purple Visits app.',
            url: 'https://virtual-visits-public.s3.eu-west-2.amazonaws.com/how-to-videos/review-call.mp4'
          },
          {
            title: 'Adding wings and checking terminal stock',
            description: 'This video explains how to add a new wing to your web portal, check how many terminals are available in each wing, and how to adjust those stock levels.',
            url: 'https://virtual-visits-public.s3.eu-west-2.amazonaws.com/how-to-videos/wings.mp4'
          },
          {
            title: 'Add and remove additional participants',
            description: 'This video shows you how to add approved additional participants to a call during booking, and when editing call details at any time prior to a call. It will also show you how to remove an additional participant at any time before the call.',
            url: 'https://virtual-visits-public.s3.eu-west-2.amazonaws.com/how-to-videos/add-remove-additional-visitors.mp4'
          },
          {
            title: 'View awaiting requests',
            description: 'This video shows you how to view requests which are awaiting confirmation.',
            url: 'https://virtual-visits-public.s3.eu-west-2.amazonaws.com/how-to-videos/view-awaiting-confirmation.mp4'
          },
          {
            title: 'View and print approved calls',
            description: 'This video shows you how to view and print a list of approved calls between any selected dates.',
            url: 'https://virtual-visits-public.s3.eu-west-2.amazonaws.com/how-to-videos/view-calls.mp4'
          },
          {
            title: 'Completing safeguarding checks',
            description: 'This video shows you how to complete safeguarding checks on additional participants, as well as how to request additional ID if required.',
            url: 'https://virtual-visits-public.s3.eu-west-2.amazonaws.com/how-to-videos/safeguarding.mp4'
          },
          {
            title: 'View a list of users with a contact in your establishment',
            description: 'This video shows you how to view a full list of all users who have a contact in your establishment.',
            url: 'https://virtual-visits-public.s3.eu-west-2.amazonaws.com/how-to-videos/view-users.mp4'
          }
        ],
        videosDuringCall: [
          {
            title: 'Log into Master terminal and view active calls',
            description: 'This video explains how to log in to the Master Terminal, and how to view a list of calls active at that time.',
            url: 'https://virtual-visits-public.s3.eu-west-2.amazonaws.com/how-to-videos/login-mt.mp4'
          },
          {
            title: 'View an active call',
            description: 'This video shows you how you can view an active call in full screen from the Master Terminal.',
            url: 'https://virtual-visits-public.s3.eu-west-2.amazonaws.com/how-to-videos/view-active-call.mp4'
          },
          {
            title: 'Pause and terminate a call',
            description: 'This video explains how to view a call, then pause the call, speak with the resident, and how to terminate a call, all via the Master Terminal.',
            url: 'https://virtual-visits-public.s3.eu-west-2.amazonaws.com/how-to-videos/pause-and-terminate.mp4'
          },
          {
            title: 'Change security settings during a call',
            description: 'This video shows you how to change security settings in real time whilst a call is taking place.',
            url: 'https://virtual-visits-public.s3.eu-west-2.amazonaws.com/how-to-videos/change-security.mp4'
          }
        ],
        videosAfterCall: [
          {
            title: 'View completed calls and export data',
            description: 'This video shows you how to view a list of all completed calls, as well as how to export that list as a CSV file.',
            url: 'https://virtual-visits-public.s3.eu-west-2.amazonaws.com/how-to-videos/view-completed.mp4'
          },
          {
            title: 'Banning a user, and removing a user ban',
            description: 'This video shows how to apply a ban on a user profile, as well as how to remove said ban.',
            url: 'https://virtual-visits-public.s3.eu-west-2.amazonaws.com/how-to-videos/bans.mp4'
          },
          {
            title: 'View audit log and download call recording',
            description: 'This video shows you how to view the audit log, view the entire recording of the call, as well as how to download a full recording of the call footage.',
            url: 'https://virtual-visits-public.s3.eu-west-2.amazonaws.com/how-to-videos/audit-log.mp4'
          }
        ]
      };
    },
    mounted() {

    },
    methods: {

    },
  };

</script>
